export default __webpack_public_path__ + "static/bg-pattern-5accaeeb8827d5f67f604ff9ad548352.png";